import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/create",
)({
  component: Outlet,
});
